import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/Department/Form';

const DepartmentsAdd = () => (
  <>
    <PageTitle>Add Department</PageTitle>

    <Form />
  </>
);

export default DepartmentsAdd;
